import {
  PackageBuyStatusEnum, SuperMemberSourceEnum, RightPackageTypeEnum, StyleTypeEnum,
} from '@/api/rights/types';

import { MembersRightsPrefix } from '@/constant';
import { queryBuyStatus } from '@/api/rights/order/order';
import URLUtils from '../utils/URLUtils';

/** 权益管理器 */
class RightRouterHelper {
  private buyStatus: PackageBuyStatusEnum | undefined;

  // 新增：存储当前购买的卡类型
  private currentPackageType: RightPackageTypeEnum | undefined;

  private MEMBER_PREFIX = 'AppFinanceMemberH5';

  /** 管理器初始化，用来获取当前权益类型购买状态
   * 异步获取，避免阻塞页面渲染
   * 改造：同时查询普通超会和PLUS卡的购买状态，如果PLUS卡已购买，优先使用PLUS卡状态
   * currentRouter: 当前权益链接
  */
  public initBuyStatus(packageType: RightPackageTypeEnum):void {
    queryBuyStatus({
      packageType,
    }).then((res) => {
      this.buyStatus = res.packageBuyStatus;
    }).catch(() => {
      // 如果接口请求失败，默认为未购买
      this.buyStatus = PackageBuyStatusEnum.NOT_BUY;
    });
  }

  /** 根据卡种，获取当前路由分类 */
  public getCurrentRouterMap = {
    [RightPackageTypeEnum.SUPER_MEMBER_CARD]: 'super-member',
    [RightPackageTypeEnum.SUPER_MEMBER_PLUS_CARD]: 'super-member', // 新增：PLUS卡使用相同的路由
    [RightPackageTypeEnum.CHANNEL_B]: 'right-detail',
    [RightPackageTypeEnum.HAPPY_CARD]: 'highlight-right-page',
    [RightPackageTypeEnum.FAST_CARD]: 'accelerate-right-page',
    [RightPackageTypeEnum.REPAYMENT_CARD]: 'package-detail',
    [RightPackageTypeEnum.ZHEN_XIANG_MEMBER_CARD]: 'zhenxiang-member-card',
  };

  /** 分发
   * currentRouter: 当前路由
  */
  public dispatcher = (currentRouter: string): string => {
    try {
      if (!currentRouter.includes(this.MEMBER_PREFIX)) {
        return currentRouter;
      }

      const superMemberRouterName = this.getCurrentRouterMap[
        RightPackageTypeEnum.SUPER_MEMBER_CARD
      ];
      // 针对超级会员特殊处理，通过购买状态转换
      if (
        currentRouter.includes(
          superMemberRouterName,
        )) {
        const hashRegex = /#([^?#]+)/;
        const preRenderRegex = /\/([^/#]*)#/;
        const hasBought = this.buyStatus === PackageBuyStatusEnum.BOUGHT;
        const routerNamePrerender = hasBought ? `${superMemberRouterName}_bought` : superMemberRouterName;
        const routerName = hasBought ? `${superMemberRouterName}/bought` : superMemberRouterName;
        // 已购买 /pr_index_super-member_bought.html#/super-member/bought
        // 未购买 /pr_index_super-member.html#/super-member
        return currentRouter
          .replace(preRenderRegex, `/pr_index_${routerNamePrerender}.html#/`)
          .replace(hashRegex, `#/${routerName}`);
      }
      return currentRouter;
    } catch (error) {
      return currentRouter;
    }
  };

  /**
   * 会员项目路由分发
   * 根据用户购买状态做不同结果预渲染，主要用于主tab用户体验
   * 改造：支持PLUS卡的路由分发
  */
  public dispatchRouterByBuyStatus = (
    packageType: RightPackageTypeEnum,
    from: SuperMemberSourceEnum,
    buyStatus?: PackageBuyStatusEnum,
    orderId?: string,
  ): string => {
    const url = this.getCurrentRouterMap[packageType];

    if (!this.buyStatus && !buyStatus) {
      this.initBuyStatus(packageType);
    }
    if (this.buyStatus === PackageBuyStatusEnum.BOUGHT
      || buyStatus === PackageBuyStatusEnum.BOUGHT) {
      return URLUtils.formatUrl(`${MembersRightsPrefix}${url}_bought.html#/${url}/bought`, {
        packageType,
        orderId,
        from,
        hiddenNavigationBar: 1,
      });
    }
    return `${MembersRightsPrefix}${url}.html#/${url}?from=${from}&hiddenNavigationBar=1`;
  }

  /** 跳转会员订单页 */
  public getOrderUrl = (): string => `${MembersRightsPrefix}order-management.html#/order-management?&hiddenNavigationBar=1`
}

export const RightHelper = new RightRouterHelper();
